module.exports = __webpack_public_path__ + "static/media/3.e1f6f5cf.mp4";